import { render, staticRenderFns } from "./KtMaxHeight.vue?vue&type=template&id=6474e5da&"
import script from "./KtMaxHeight.vue?vue&type=script&lang=js&"
export * from "./KtMaxHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports